import * as THREE from "THREE";

export const sphere = new THREE.SphereGeometry(400, 200, 200);
